export default {"src":"https://images-cdn-staging.curipod.com/d-f123b2ee/_next/static/media/wake_county_wcpss.dd36f474.svg","height":67,"width":250};